export class SidePanelCloseEvent extends Event {
   static EVENT_NAME = 'side-panel-close';

   constructor() {
      super(SidePanelCloseEvent.EVENT_NAME, {
          bubbles: true,
         composed: true});
   }
}

export class SidePanelClosedEvent extends Event {
   static EVENT_NAME = 'side-panel-closed';

   constructor() {
      super(SidePanelClosedEvent.EVENT_NAME, {
          bubbles: true,
         composed: true});
   }
}

export class SidePanelCloseBlockedEvent extends CustomEvent<{triggeredByCloseButton: boolean}> {
   static EVENT_NAME = 'side-panel-close-blocked';
    
    constructor(triggeredByCloseButton: boolean) {
      super(SidePanelCloseBlockedEvent.EVENT_NAME, {
          bubbles: true,
          composed: true,
          detail: { triggeredByCloseButton }
      });       
    }
}

export class SidePanelOpenEvent extends Event {
   static EVENT_NAME = 'side-panel-open';

   constructor() {
      super(SidePanelOpenEvent.EVENT_NAME, {
          bubbles: true,
         composed: true});
   }
}

export class SidePanelOpenedEvent extends Event {
   static EVENT_NAME = 'side-panel-opened';

   constructor() {
      super(SidePanelOpenedEvent.EVENT_NAME, {
          bubbles: true,
         composed: true});
   }
}
